import { __assign, __awaiter, __generator } from "tslib";
import { loadTypedefs, loadTypedefsSync } from './load-typedefs';
import { Source as GraphQLSource, print } from 'graphql';
import { OPERATION_KINDS } from './documents';
import { mergeSchemasAsync, mergeSchemas } from '@graphql-tools/merge';
/**
 * Asynchronously loads a schema from the provided pointers.
 * @param schemaPointers Pointers to the sources to load the schema from
 * @param options Additional options
 */
export function loadSchema(schemaPointers, options) {
    return __awaiter(this, void 0, void 0, function () {
        var sources, _a, schemas, typeDefs, mergeSchemasOptions, schema;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, loadTypedefs(schemaPointers, __assign({ filterKinds: OPERATION_KINDS }, options))];
                case 1:
                    sources = _b.sent();
                    _a = collectSchemasAndTypeDefs(sources), schemas = _a.schemas, typeDefs = _a.typeDefs;
                    mergeSchemasOptions = __assign({ schemas: schemas,
                        typeDefs: typeDefs }, options);
                    return [4 /*yield*/, mergeSchemasAsync(mergeSchemasOptions)];
                case 2:
                    schema = _b.sent();
                    if (options === null || options === void 0 ? void 0 : options.includeSources) {
                        includeSources(schema, sources);
                    }
                    return [2 /*return*/, schema];
            }
        });
    });
}
/**
 * Synchronously loads a schema from the provided pointers.
 * @param schemaPointers Pointers to the sources to load the schema from
 * @param options Additional options
 */
export function loadSchemaSync(schemaPointers, options) {
    var sources = loadTypedefsSync(schemaPointers, __assign({ filterKinds: OPERATION_KINDS }, options));
    var _a = collectSchemasAndTypeDefs(sources), schemas = _a.schemas, typeDefs = _a.typeDefs;
    var mergeSchemasOptions = __assign({ schemas: schemas,
        typeDefs: typeDefs }, options);
    var schema = mergeSchemas(mergeSchemasOptions);
    if (options === null || options === void 0 ? void 0 : options.includeSources) {
        includeSources(schema, sources);
    }
    return schema;
}
function includeSources(schema, sources) {
    schema.extensions = __assign(__assign({}, schema.extensions), { sources: sources
            .filter(function (source) { return source.rawSDL || source.document; })
            .map(function (source) { return new GraphQLSource(source.rawSDL || print(source.document), source.location); }) });
}
function collectSchemasAndTypeDefs(sources) {
    var schemas = [];
    var typeDefs = [];
    sources.forEach(function (source) {
        if (source.schema) {
            schemas.push(source.schema);
        }
        else {
            typeDefs.push(source.document);
        }
    });
    return {
        schemas: schemas,
        typeDefs: typeDefs,
    };
}
//# sourceMappingURL=schema.js.map